import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { DownArrow } from '../icons/down-arrow';
import { BlueCheckmark } from '../icons/BlueCheckmark';
import {
  DescriptiveControl,
  DescriptiveOptionDescription,
  DescriptiveOptionLabel,
} from './StyledDropdown';
import { Help } from '../inputs/styled-input';
import { DropdownProps } from '.';

import styles from './DescriptiveDropdown.module.scss';
type DescriptiveDropdownProps = DropdownProps & {
  helpText?: string;
  label?: string;
  required?: boolean;
};
/**
 * Mostly a copy of Inline Descriptive dropdown...
 * We can share most of the design but the main control item is really different
 * @constructor
 */
export const DescriptiveDropdown: React.FC<DescriptiveDropdownProps> = ({
  onChange,
  options,
  value,
  label,
  helpText,
  required,
}) => {
  const handleChange = (value: string) => {
    onChange(value);
  };

  const chosenElement = options.find((el) => el.value === value);

  return (
    <div>
      {label && (
        <label>
          {label} {required && <b>*</b>}
        </label>
      )}

      {helpText && <Help>{helpText}</Help>}

      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <DescriptiveControl>
            <div className={styles['chosen-option-container']}>
              <div className={styles['chosen-option']}>
                <DescriptiveOptionLabel>{chosenElement?.label}</DescriptiveOptionLabel>
                <DownArrow />
              </div>

              <DescriptiveOptionDescription>
                {chosenElement?.description}
              </DescriptiveOptionDescription>
            </div>
          </DescriptiveControl>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content className={styles['option']} sideOffset={4} align="start">
            {options!.map((el, index) => (
              <DropdownMenu.Item
                className={styles['list-item']}
                key={index}
                data-active={el.value === value}
                onSelect={() => handleChange(el.value)}
              >
                <DescriptiveOptionLabel>
                  {el.label} {el.value === value && <BlueCheckmark />}
                </DescriptiveOptionLabel>
                <DescriptiveOptionDescription>{el?.description} </DescriptiveOptionDescription>
              </DropdownMenu.Item>
            ))}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
};
